<template>
  <div class="grade">
    <img class="hand-img" v-lazy="img.member_bg">
    <div class="message">
      <div class="info">
        <van-row>
          <van-col span="6"><img class="head" :src="user.avatar?user.avatar:img.member_bg"></van-col>
          <van-col span="18"><div class="f-14 f-w ml-10 pd-35">{{user.username}}</div></van-col>
        </van-row>
        <div class="pd-20">
          <div class="grade-box">
            <div class="gradeimg f-l" :style="'background-image:url('+img.grade+')'">
              <span class="gradeinfo">{{info.level}}</span>
            </div>
            <div class="gradeimg f-r" :style="'background-image:url('+img.grade+')'">
              <span class="gradeinfo">{{info.level+1}}</span>
            </div>
          </div>
          <div class="progressbox">
            <div class="myprogress" :style="{'width':progress}"></div>
          </div>
        </div>
        <van-grid :column-num="3" :border="false">
          <van-grid-item>
            <div class="f-w f-16"><img class="lv" :src="img.lv">{{info.level}}</div><div class="c-gray">我的等级</div>
          </van-grid-item>
          <van-grid-item>
            <div class="f-w f-16">{{info.rank}}</div><div class="c-gray">我的排名</div>
          </van-grid-item>
          <van-grid-item>
            <div class="f-w f-16">{{info.diff}}</div><div class="c-gray">升级还差</div>
          </van-grid-item>
        </van-grid>
      </div>
    </div>
    <div class="mt-30 pd-20">
      <div class="f-16 f-w">今日奖励</div>
      <van-cell v-for="item in tasks" :key="'list_' + item.id" :title="item.title" value="已获得" size="large" :label="'经验+'+item.exp +' , 积分+'+item.integral" />
      <div class="text-c" v-if="tasks.length>4">
        <van-button size="small">展开</van-button>
      </div>
    </div>
    <div class="pd-20 peroga" hidden="true">
      <span class="f-16 f-w">等级特权</span>
      <div class="f-12">·享有此荣耀的车主，可以优先获得活动特权</div>
      <div class="f-12">·享有此荣耀的车主，可以优先获得活动特权</div>
      <div class="f-12">·享有此荣耀的车主，可以优先获得活动特权</div>
      <div class="f-12">·享有此荣耀的车主，可以优先获得活动特权</div>
    </div>
    <div class="mt-30 pd-20 peroga cellbox">
      <van-cell class="cellget" title="了解等级特权" is-link to="gradeinfo" />
    </div>
  </div>
</template>
<script>
  import common from '../../../api/common';
  import member from '../../../api/member/memberinfo';
  import { mapState } from 'vuex';
  import { List, Row, Col, Button, Grid, GridItem, Image, Icon,Step, Steps,Cell, CellGroup } from 'vant';
  export default {
    data () {
      return {
        progress:'0',
        params:{
          source:'',
        },
        info:'',
        tasks:[],
        img:{
          member_bg: require('../../../assets/img/lexus/my/member_bg.png'),
          grade: require('../../../assets/img/lexus/my/grade.png'),
          lv: require('../../../assets/img/lexus/my/lv.png')
        }
      }
    },
    computed: {
      ...mapState({
        user: state => state.param.user,
        source: state => state.param.source
      })
    },
    created () {
      this.$store.commit('param/show', false)
      this.$appService.isShowReturn({state: true})
      this.$appService.isTabbar({state: true})
      this.params.source=this.source
      this.$appService.getToken(v => {
        if(v.token) {
          this.$store.dispatch('param/setToken', v.token)
        } else {
          this.$appService.needLogin()
        }
      })
      this.getMyGrade()
      var params={
        event_code: '我的等级',
        event_id: '',
        title: '',
        value: '',
        path: '/Lexus/My/MyGrade.vue',
        user_id: this.user ? this.user.id : 0,
        source: this.source
      }
      common.BurialPoint(params).then(res => {
        if(res.data.state==1){
        }
      })
      var apppar={
        title:this.$route.meta.title
      }
      this.$appService.changeTitle(apppar)
    },
    methods: {
      getMyGrade(){
       member.getMyGrade(this.params).then(res => {
        this.info=res.data.data
        this.progress=res.data.data.progress+'%'
        this.tasks=res.data.data.tasks
      })
     }
   },
   components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [List.name]: List,
    [Button.name]: Button,
    [Image.name]:Image,
    [Icon.name]:Icon,
    [Step.name]:Step,
    [Steps.name]:Steps,
    [Cell.name]:Cell,
    [CellGroup.name]:CellGroup
  }
}
</script>

<style lang="scss">
.grade{
  .hand-img{
    width: 100%;
    height: 280px;
  }
  .message{
    font-size: 12px;
    margin-top: -55%;
    padding: 0 15px;
    line-height: 2;
    .van-col--6{
      text-align: center;
    }
    .van-tag {
      padding: 5px 10px;
      letter-spacing: 3px;
      border-radius: 1.5px;
    }
    .info{
      width: 100%;
      height: 220px;
      z-index: 99;
      position: relative;
      margin-top: 20px;
      background-color: #fff;
      border-radius: 1.5px;
      box-shadow: 5px 20px 5px rgba(0, 0, 0, 0.05);
      .head{
        width: 60px;
        height: 60px;
        border-radius: 1.5px;
        padding: 20px;
      }
      .lv{
        width: 17px;
      }
      .grade-box{
        width: 100%;
        height: 25px;
      }
      .gradeimg{
        width: 50px;
        height: 25px;
        background-size: 50px 25px;
        background-repeat:no-repeat;
        .gradeinfo{
          color: #fff;
          margin-left: 28px;
        }
      }
      .progressbox{
        width: 100%;
        height: 7px;
        background-color: #F8F8F8;
        border:1px solid #F8F8F8;
        margin-top: 5px;
        .myprogress{
          height: 7px;
          background-color: #605C6B;
        }
      }
    }
  }
  .van-button{
    padding:0 25px;
    color: #728FC4;
    margin:20px;
    background-color: #F2F6FA;
  }
  .peroga{
    line-height: 2;
    border-top: 10px solid #f8f8f8;
  }
  .cellbox{
    height: 50px;
    .cellget{
      padding: 16px 0;
    }
  }
  .pd-35{
    padding-top: 35px;
  }
  .pd-20{
    padding: 0 20px;
  }
  .ml-10{
    margin-left: 10px;
  }
  .mt-30{
    margin-top: 30px;
  }
}
</style>
